import "./Icon.css";

const Icon = ({ children, className, style }) => {
  return (
    <span className={`icon ${className ?? ""}`} style={style}>
      {children}
    </span>
  );
};

export default Icon;
